import { whiteLight, grayHard } from 'styleVars/getColors';

const grayBorder = '#c5c5c5'; // TODO: Ask Adam to give this color the name

function arrowGenerator(color) {
  return {
    opacity: 1,
    '&[x-placement*="top-start"] $htmlTooltip, &[x-placement*="bottom-start"] $htmlTooltip': {
      marginLeft: '-15px',
    },
    '&[x-placement*="top-start"] $arrow, &[x-placement*="bottom-start"] $arrow': {
      '&::after, &::before': {
        left: '16px',
      },
    },
    '&[x-placement*="top-end"] $htmlTooltip, &[x-placement*="bottom-end"] $htmlTooltip': {
      marginRight: '-15px',
    },
    '&[x-placement*="top-end"] $arrow, &[x-placement*="bottom-end"] $arrow': {
      '&::after, &::before': {
        right: '16px',
      },
    },
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      marginTop: '-0.95em',
      width: '3em',
      height: '1em',
      opacity: 1,
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        zIndex: 5,
        borderColor: `transparent transparent ${ color } transparent`,
      },
      '&::after': {
        top: '-2px',
        zIndex: 4,
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent ${ grayBorder } transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      marginBottom: '-0.95em',
      width: '3em',
      height: '1em',
      opacity: 1,
      '&::before, &::after': {
        borderWidth: '1em 1em 0 1em',
      },
      '&::before': {
        zIndex: 5,
        borderColor: `${ color } transparent transparent transparent`,
      },
      '&::after': {
        bottom: '-1px',
        zIndex: 4,
        borderColor: `${ grayBorder } transparent transparent transparent`,
      },
    },
  };
}

export const styles = () => ({
  arrow: {
    position: 'absolute',
    fontSize: 6,
    width: '3em',
    height: '3em',
    opacity: 1,
    '&::before, &::after': {
      content: '""',
      margin: 'auto',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      left: '2px',
      width: 0,
      height: 0,
      borderColor: whiteLight,
      borderStyle: 'solid',
    },
  },
  htmlPopper: arrowGenerator(whiteLight),
  htmlTooltip: {
    boxSizing: 'border-box',
    backgroundColor: whiteLight,
    color: grayHard,
    borderRadius: '10px',
    padding: '7px 16px',
    maxWidth: 350,
    fontSize: '20px',
    border: `1px solid ${ grayBorder }`,
    boxShadow: '0 0 19px 0 rgba(0, 0, 0, 0.2)',
  },
});
